function SitesTokens({ id }: any) {
  return <>Tokens {id}</>;
}

export default SitesTokens;
